// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  palette: { greyscale, noodle },
} = getTheme();
const RequestListWrapper: StatelessFunctionalComponent<any> = styled.div`
  .request-list {
    &__container {
      align-items: center;
      background-color: ${greyscale.white};
      bottom: -7rem;
      box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: center;
      left: 0;
      padding: 0.8rem 2.4rem;
      position: fixed;
      width: 100%;
      transition: bottom 0.2s;
    }

    &__request {
      align-items: center;
      color: ${greyscale.white};
      cursor: pointer;
      background-color: ${noodle.primary};
      border-radius: 0.4rem;
      display: flex;
      font-size: 1.6rem;
      height: 4.8rem;
      justify-content: center;
      line-height: 1.9rem;
      margin-left: 2.4rem;
      transition: all 0.3s;
      width: 22.4rem;

      &:hover {
        background-color: ${noodle.secondary};
      }
    }

    &__reset {
      color: ${greyscale.outerSpace};
      cursor: pointer;
      font-size: 1.6rem;
      line-height: 1.6rem;
      margin-right: 2.4rem;
      outline: none;
      white-space: nowrap;
    }
  }

  .is-open {
    bottom: 0;
  }
`;
export default RequestListWrapper;
